/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect, useState } from 'react'
import { useGlobal } from 'providers/hooks'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import { LanguageSwitcherV2 } from '../language-switcher-v2'

interface Props {
  setLocale: (lng: string) => void
  wifi: string | undefined | null
  description: string | undefined | null
  showCaloriesBtn: boolean | undefined | null
  showAllergensBtn: boolean | undefined | null
  isLoading: boolean
  sub_description: string | undefined | null
  restaurantName?: string | null | undefined
  imgUrl?: string | null | undefined
}

export const HeaderV2: React.FC<Props> = ({
  setLocale,
  wifi,
  showCaloriesBtn,
  showAllergensBtn,
  description,
  isLoading,
  sub_description,
  restaurantName,
  imgUrl
  // body_font
}) => {
  const [state, setState] = useState({
    allergens: false,
    calories: false
  })

  const [showSettings, setShowSettings] = useState(false)

  const [searchParams] = useSearchParams()

  const { t } = useTranslation()
  const global = useGlobal()

  const handleAllergens = () => {
    setState({ allergens: !state.allergens, calories: state.calories })
    global.handleAllergens()
  }

  const handleCalories = () => {
    setState({ allergens: state.allergens, calories: !state.calories })
    global.handleCalories()
  }

  if (isLoading) {
    return <Skeleton height={30} count={3} />
  }

  return (
    <header className="font-mammaTitle bg-primary text-tertiary z-20 relative">
      <div
        className={`grid ${searchParams.get('hide_reservation') ? 'grid-cols-[1fr_auto]' : 'grid-cols-[1fr_auto_1fr]'} py-2 px-4`}
      >
        {!searchParams.get('hide_reservation') && <div></div>}
        <div>
          {(imgUrl && (
            <img
              className="h-10 w-40 object-contain object-left"
              src={imgUrl}
              alt={restaurantName || 'restaurant logo'}
            />
          )) ||
            restaurantName}
        </div>
        <div className="flex justify-end items-center gap-2.5">
          <LanguageSwitcherV2 setLocale={(lng) => setLocale(lng)} />
          {(showCaloriesBtn || showAllergensBtn) && (
            <button onClick={() => setShowSettings(true)}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.57129 8.14286L14.1427 8.14286M14.1427 8.14286C14.1427 9.32633 15.1021 10.2857 16.2856 10.2857C17.469 10.2857 18.4284 9.32632 18.4284 8.14286C18.4284 6.95939 17.469 6 16.2856 6C15.1021 6 14.1427 6.95939 14.1427 8.14286ZM9.857 14.8571L18.4284 14.8571M9.857 14.8571C9.857 16.0406 8.89761 17 7.71415 17C6.53068 17 5.57129 16.0406 5.57129 14.8571C5.57129 13.6737 6.53068 12.7143 7.71415 12.7143C8.89761 12.7143 9.857 13.6737 9.857 14.8571Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
      {(showCaloriesBtn || showAllergensBtn) && (
        <React.Fragment>
          <div
            className={`fixed ${showSettings ? 'block' : 'hidden pointer-events-none'} text-primary z-50 bottom-0 left-1/2 -translate-x-1/2 h-auto w-full max-w-[768px] rounded-t-[6px] bg-white p-4 pt-6`}
          >
            {showCaloriesBtn && (
              <button
                onClick={handleCalories}
                className="font-mammaDescription flex items-center gap-6 justify-between w-full"
              >
                {t('showCalories')}
                <div
                  className={`rounded-full w-[56px] h-[29px] ${state.calories ? 'bg-primary justify-end' : 'bg-[#C5C5C6] justify-start'} flex items-center p-0.5`}
                >
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12.5" cy="12.5" r="12.5" transform="matrix(-1 0 0 1 25 0)" fill="white" />
                  </svg>
                </div>
              </button>
            )}
            {showCaloriesBtn && showAllergensBtn && <hr className="my-4 border-0 border-t border-primary" />}
            {showAllergensBtn && (
              <button
                onClick={handleAllergens}
                className="font-mammaDescription flex items-center gap-6 justify-between w-full"
              >
                {t('showAllergens')}
                <div
                  className={`rounded-full w-[56px] h-[29px] ${state.allergens ? 'bg-primary justify-end' : 'bg-[#C5C5C6] justify-start'} flex items-center p-0.5`}
                >
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12.5" cy="12.5" r="12.5" transform="matrix(-1 0 0 1 25 0)" fill="white" />
                  </svg>
                </div>
              </button>
            )}

            <button
              className="mt-[60px] w-full flex items-center justify-center text-[12px] uppercase font-bold tracking-[0.02em] bg-primary h-[50px] text-tertiary"
              onClick={() => setShowSettings(false)}
            >
              {t('close')}
            </button>
          </div>
          <div
            className={`fixed ${showSettings ? 'block' : 'hidden pointer-events-none'} z-40 bg-black/50 top-0 left-0 w-full h-full cursor-pointer`}
            onClick={() => setShowSettings(false)}
          ></div>
        </React.Fragment>
      )}
    </header>
  )
}
